import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Filters from "../components/Filters";
import Transaction from "../components/Transactions/Transaction";
import EditTransactionModal from "../components/Ui/EditTransactionModal";
import Pagination from "../components/Ui/Pagination";
import {
    clearFilter,
    setActiveId,
    setCurrentPage,
} from "../features/filter/filterSlice";
import { fetchTransactions } from "../features/transaction/transactionSlice";

const AllTransactions = () => {
    const dispatch = useDispatch();
    const { isLoading, isError, transactions } = useSelector(
        (state) => state.transaction
    );
    const { currentPage, transactionPerPage, searchText, searchType } =
        useSelector((state) => state.filter);
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(fetchTransactions({ searchType }));
    }, [dispatch, searchType]);

    let filteredTransactions = [];
    if (searchText?.length > 0) {
        filteredTransactions = transactions?.filter((transaction) =>
            transaction?.name?.toLowerCase().includes(searchText)
        );
    }

    const resetPagination = () => {
        dispatch(setCurrentPage(1));
        dispatch(setActiveId(1));
    };

    // Get current videos
    const indexOfLastTransaction = currentPage * transactionPerPage;
    const indexOfFirstTransaction = indexOfLastTransaction - transactionPerPage;
    const currentTransactions =
        filteredTransactions?.length > 0
            ? filteredTransactions?.slice(
                  indexOfFirstTransaction,
                  indexOfLastTransaction
              )
            : transactions?.slice(
                  indexOfFirstTransaction,
                  indexOfLastTransaction
              );

    const handleHomeNavigation = () => {
        resetPagination();
        dispatch(clearFilter());
        navigate("/");
    };

    //decide what to render
    let content = null;

    if (isLoading) content = <p>Loading...</p>;

    if (!isLoading && isError)
        content = <p className="error">there was an error ocurred!</p>;

    if (!isLoading && !isError && transactions.length === 0)
        content = <p>No Data Found.</p>;

    if (!isLoading && !isError && transactions.length > 0) {
        content =
            searchText?.length > 0 && filteredTransactions?.length === 0 ? (
                <p className="no_transaction_search">No Transaction Found.</p>
            ) : (
                currentTransactions?.map((transaction) => (
                    <Transaction
                        key={transaction?.id}
                        transaction={transaction}
                    />
                ))
            );
    }

    return (
        <>
            <p onClick={handleHomeNavigation} className="home_link">
                Home
            </p>
            <Filters resetPagination={resetPagination} />
            <section className="all_transactions">{content}</section>
            {searchText?.length > 0 &&
            filteredTransactions?.length === 0 ? null : (
                <Pagination
                    filteredTransactions={filteredTransactions}
                    currentTransactions={currentTransactions}
                />
            )}
            <EditTransactionModal />
        </>
    );
};

export default AllTransactions;
